import { render, staticRenderFns } from "./WarehouseResortForm.vue?vue&type=template&id=2c54f758&"
import script from "./WarehouseResortForm.vue?vue&type=script&lang=ts&"
export * from "./WarehouseResortForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports